import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SETTING_KEY_USER, ShowFilterType, UserSettingModel } from 'Modules'
import { Callback } from 'Types/utilTypes'
import { UpdateSettingsData } from 'Types/filters'
import { WidgetNames } from 'Pages/dashboard'

export type UserSettingState = {
	settings: UserSettingModel | null
}

const initialState: UserSettingState = {
	settings: null,
}

export namespace UserSettingNS {
	export type UpdateSettings = PayloadAction<{
		data: UpdateSettingsData | WidgetNames[] | number
		key: SETTING_KEY_USER
		isShowNotification?: boolean
		callback?: Callback
		errorCallback?: Callback
	}>
	export type UpdateShowFilters = PayloadAction<ShowFilterType>
	export type SetSettings = PayloadAction<UserSettingModel>
	export type GetSettings = PayloadAction
	export type DestroyStore = PayloadAction
}

export const userSettingSlice = createSlice({
	name: 'userSetting',
	initialState,
	reducers: {
		updateSettings: (state, action: UserSettingNS.UpdateSettings) => {},
		updateShowFilters: (state, action: UserSettingNS.UpdateShowFilters) => {
			const { key, isShowFilters } = action.payload
			if (!state.settings.data[key]) {
				state.settings.data[key] = {}
			}
			state.settings.data[key].isShowFilters = isShowFilters
		},
		setSettings: (state, action: UserSettingNS.SetSettings) => {
			state.settings = action.payload
		},
		getSettings: (state, action: UserSettingNS.GetSettings) => {},
		destroyStore: (state, action: UserSettingNS.DestroyStore) => {},
	},
})
